module.exports = __webpack_public_path__ + "static/media/Icon - network.ec13e3e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements/Icon - network.svg
// module id = 31
// module chunks = 0